import {Component, Inject, QueryList, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '@nh/angular-tses';
import {DepartureCommentType} from 'app/comment/departure-comment-type';
import {EnvironmentVariableService} from 'app/core/services/environment-variable.service';
import {ReasonCodeService} from 'app/diary/reason-codes/reason-codes.service';
import {Reassignment, RoleService} from '../../../core/services/role.service';
import {UserAutocompleteComponent} from '../../../core/user-autocomplete/user-autocomplete.component';
import {DiaryService} from '../../../diary/diary.service';
import {DepartureRole} from '../../../permissions/types';
import {BaseTransitionModalComponent} from '../base-transition-modal/base-transition-modal.component';
import {TransitionInputData} from '../transition-input-data';
import {TransitionOutputData} from '../transition-output-data';

export interface AssignableRole {
  role: DepartureRole;
  users: User[];
}

@Component({
  selector: 'das-user-assign-modal',
  templateUrl: './user-assign-modal.component.html',
  styleUrls: ['./user-assign-modal.component.scss', '../base-transition-modal/base-transition-modal.component.scss'],
})
export class UserAssignModalComponent extends BaseTransitionModalComponent {
  protected reassignments: Reassignment[] = [];

  @ViewChildren(UserAutocompleteComponent) public assignmentFields: QueryList<UserAutocompleteComponent>;

  constructor(
    public dialogRef: MatDialogRef<UserAssignModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransitionInputData,
    roleService: RoleService,
    diaryService: DiaryService,
    reasonCodeService: ReasonCodeService,
    environmentVariableService: EnvironmentVariableService
  ) {
    super(dialogRef, data, roleService, diaryService, reasonCodeService, environmentVariableService);
  }

  public actionButtonText(): string {
    return this.data && this.data.actionButton ? this.data.actionButton : 'ASSIGN';
  }

  public assign(): void {
    const returnData: TransitionOutputData = {
      cancelled: false,
      snapShot: super.generateDiarySnapshot(
        this.inputComment.value,
        DepartureCommentType.COMMENT,
        this.reassignments.splice(0),
        {}
      ),
    };
    this.dialogRef.close(returnData);
  }

  public checkFormValidity(): boolean {
    let formValid: boolean = false;
    if (this.inputComment.valid && this.assignmentFields && this.assignmentFields.length > 0) {
      let allValid: boolean = true;
      this.assignmentFields.forEach((child: UserAutocompleteComponent) => {
        if (child.formControl.invalid) {
          allValid = false;
        }
      });
      formValid = allValid;
    }
    return formValid;
  }

  public cancel(): void {
    super.cancel();
  }

  public selected(user: User, assignment: AssignableRole): void {
    this.reassignments = this.reassignments.filter((currentReassignment: Reassignment) => {
      return currentReassignment.role !== assignment.role;
    });
    this.reassignments.push({
      role: assignment.role,
      user: user,
    });
  }
}
